import React, { useContext } from 'react';
import { useQuery, gql } from '@apollo/client';
import { Context } from '../../../store/store';
import GoBackToMainMenuButton from '../go-back-to-main-menu-button';
import {
  StyledBookmarksSidebar,
  StyledBookmarksWrapper,
  Header,
  StyledLine,
} from './bookmarks-sidebar.styles';
import BookmarkItem from './bookmark-item';

const BookmarksSidebar = () => {
  const [state] = useContext(Context);
  const { loading, error, data } = useQuery(FETCH_BOOKMARKS, {
    variables: { id: state.bookId },
  });
  if (loading)
    return (
      <StyledBookmarksSidebar>
        <p style={{ textAlign: 'center' }}>Загрузка закладок…</p>
      </StyledBookmarksSidebar>
    );
  if (error)
    return (
      <StyledBookmarksSidebar>
        <p style={{ textAlign: 'center' }}>Ошибка: {error.message}</p>
      </StyledBookmarksSidebar>
    );
  return (
    <StyledBookmarksSidebar isOpened={state.isBookmarksSidebarOpened}>
      <Header>
        <GoBackToMainMenuButton />
        <span>Закладки ({data?.book?.bookmarks.length})</span>
        <span></span>
      </Header>
      <StyledLine />
      <StyledBookmarksWrapper>
        {data?.book?.bookmarks?.map(bookmark => (
          <BookmarkItem
            key={bookmark.ts}
            page={bookmark.page}
            text={bookmark.text}
            ts={bookmark.ts}
          />
        ))}
      </StyledBookmarksWrapper>
    </StyledBookmarksSidebar>
  );
};

const FETCH_BOOKMARKS = gql`
  query Book($id: ID!) {
    book(id: $id) {
      id
      title
      bookmarks {
        page
        text
        ts
      }
    }
  }
`;

export default BookmarksSidebar;
